import React, { useCallback, useEffect, useMemo } from "react";
import Table from "components/Table/table";
import { useSelector } from "react-redux";
import { useState } from "react";
import { formatUsDate } from "utils/date";
import { sortObjectKeys, titleCase } from "../../utils/util.ts";

const InActiveResources = () => {
    const [inactiveResourcesItems, setInactiveResourcesItems] = useState([]);
    const [currentViewId, setCurrentViewId] = useState(1);
    const inactive_resources = useSelector(
        (state) => state.cloudCounter.inactive_resources
    );

    const sortedList = useMemo(
        () =>
            inactive_resources.length > 0
                ? sortObjectKeys(inactive_resources[0]?.data)
                : [],
        [inactive_resources]
    );

    const currentCount = inactive_resources[0]?.data;
    const previousCount = useMemo(
        () =>
            inactive_resources.find((info) => info.id === currentViewId)
                ?.data || {},
        [currentViewId, inactive_resources]
    );

    const updateDataTable = useCallback(() => {
        const items = sortedList.map((row, id) => {
            const title = titleCase(row[0]);
            const currentValue = currentCount[row[0]];
            const previousValue = previousCount[row[0]] ?? 0;
            const percentageDiff = previousValue
                ? (
                      ((currentValue - previousValue) / previousValue) *
                      100
                  ).toFixed(2)
                : "N/A";

            return {
                id,
                title,
                currentCount: currentValue,
                previousCount: previousValue,
                percentageDiff: percentageDiff + "%",
            };
        });
        setInactiveResourcesItems(items);
    }, [currentCount, previousCount, sortedList]);

    useEffect(() => {
        updateDataTable();
    }, [currentViewId, updateDataTable]);

    const date = useMemo(() => {
        const selectedDate = inactive_resources.find(
            (info) => info.id === currentViewId
        )?.date;
        return formatUsDate(selectedDate);
    }, [currentViewId, inactive_resources]);

    return (
        <div>
            <Table data={inactiveResourcesItems} prevDate={date} />
        </div>
    );
};

export default InActiveResources;
